import React, { useState, useEffect, useMemo } from 'react'
import { useParams, Link } from "react-router-dom"
import axios from "axios"
import Nav from './Nav'
import Pagination from '../pages/paginations'

const View = () => {
    const { kategori } = useParams()
    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize] = useState(12) // Biasanya 12 biar pas (3 kolom x 4 baris atau 4x3)
    const [data, setData] = useState([])

    // Helper biar gak nulis .replaceAll berkali-kali
    const formatKategori = (slug) => {
        if (!slug) return ""
        return slug.replaceAll('-', ' ').replaceAll('_', '/') // Hapus toUpperCase()
    }

    const kategoriClean = formatKategori(kategori)

    useEffect(() => {
        getData(kategori, '')
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [kategori]) // Tambahin kategori biar pas pindah menu data ke-refresh

    const getData = async (cat, value) => {
        try {
            // Logic penentuan kategori
            const targetCat = cat ? formatKategori(cat) : kategoriClean

            const response = await axios.post("/api/kegiatan-usaha/filter", {
                key: value ? value : '',
                kategori: targetCat,
                jml: 3000
            })

            // Safety check: pastiin data itu array
            const result = response.data && Array.isArray(response.data) ? response.data : []
            setData(result)
            setCurrentPage(1)
        } catch (err) {
            console.error("Gagal ambil data:", err)
            setData([])
        }
    }

    const tableData = useMemo(() => {
        if (!data) return []
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return data.slice(firstPageIndex, lastPageIndex)
    }, [data, currentPage, PageSize])

    return (
        <header className="ms-hero-page-override-home no-mt pb-4">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb breadcrumb-slash">
                        <li className="breadcrumb-item">
                            <Link to={'/'} className="btn btn-raised btn-primary br-2 no-m">BERANDA</Link>
                        </li>
                        <li className="breadcrumb-item active">KEGIATAN USAHA</li>
                        <li className="breadcrumb-item active">{kategoriClean.toUpperCase()}</li>
                    </ol>
                    <div className="btn-group w-300">
                        <button type="button" className="btn btn-warning btn-raised dropdown-toggle" data-toggle="dropdown">
                            {kategoriClean.toUpperCase()} <i className="zmdi zmdi-chevron-down right only"></i>
                        </button>
                        <Nav getKategori={getData} />
                    </div>
                </nav>

                <div className="row mt-4">
                    <div className="col-md-12">
                        <h1 className='color-dark font-bold lh-125'>{kategoriClean.toUpperCase()}</h1>
                        <p className="lead color-dark">Telusuri {kategoriClean.toLowerCase()} di Kota Bekasi</p>
                        <hr />

                        <div className="row mb-4">
                            <div className="col-md-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Cari berdasarkan nama atau wilayah..."
                                    onChange={(e) => getData('', e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="row">
                            {tableData.length > 0 ? tableData.map((val, index) => (
                                <div className="col-md-3 mb-3" key={index}>
                                    <Link to={'/kegiatan-usaha/' + kategori.toLowerCase() + '/' + val.potensialCode} className="panel panel-dark panel-primary card-hover" style={{ textDecoration: 'none' }}>
                                        <div className="panel-heading">
                                            <h3 className='panel-title text-truncate'>{val.name}</h3>
                                        </div>
                                        <div className="panel-body no-p overflow-hidden">
                                            <img className='d-flex mr-3 media-object' style={{ width: '100%', height: '200px', objectFit: 'cover' }} src={(val.imagePath && val.imagePath !== '-') ? val.imagePath : val.categoryPath} alt={val.name} />
                                        </div>
                                    </Link>
                                </div>
                            )) : (
                                <div className="col-md-12 text-center p-5">
                                    <h4 className="color-dark">Data tidak ditemukan...</h4>
                                </div>
                            )}
                        </div>

                        {data.length > PageSize && (
                            <div className="text-center p-4">
                                <Pagination className="pagination-bar" currentPage={currentPage} totalCount={data.length} pageSize={PageSize} onPageChange={page => setCurrentPage(page)} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    )
}

export default View